export const isAppleUserAgent = (userAgent: string) => /Mac|iPhone|iPad|iPod/.test(userAgent);

export const isAppleDevice = () => isAppleUserAgent(navigator.userAgent);
